<div class="d-flex">
  <button class="button button--blue logout-btn" (click)="logout()">Logout</button>
</div>
